import { AbortedError } from 'src/common/api/extended-emerald-error';
import {
  closeCustomerCaptureDialog,
  CustomerCaptureProps,
  showCustomerCaptureDialog,
} from 'src/return-services-display/components/customer-capture';
import {
  CustomerDetailsFieldsObj,
  CustomerDetailsInfo,
} from 'src/return-services-display/interfaces';
import { ReturnsType } from 'src/transaction-search/interfaces/get-effective-return-policy-response';
import { startReturnTypeTransaction } from '../return-transaction';

export const validateCustomerInputs = (inputs: CustomerDetailsInfo) => {
  let isDisabled = false;
  Object.keys(inputs).forEach(element => {
    if (inputs[element].required && inputs[element].value === '') {
      isDisabled = true;
    }
  });
  return isDisabled;
};

export const handleInputChange = (
  name: string,
  inputFields: CustomerDetailsInfo,
  setFields: React.Dispatch<React.SetStateAction<CustomerDetailsInfo>>,
) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  const newInputField = {
    [name.replace('Required', '')]: {
      required: true,
      value: e.target.value,
    },
  };
  setFields({ ...inputFields, ...newInputField });
};

export const handleCustomerCapture = (
  returnType: ReturnsType,
  inputFields: CustomerDetailsFieldsObj,
  tlogId?: string,
): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    const onClose = () => {
      closeCustomerCaptureDialog();
      reject(new AbortedError());
    };
    const onSubmit = (customerInfo: CustomerDetailsInfo) => {
      closeCustomerCaptureDialog();
      startReturnTypeTransaction(returnType, customerInfo, tlogId)
        .then(resolve)
        .catch(reject);
    };
    const props: CustomerCaptureProps = {
      onClose,
      onSubmit,
      customerDetails: inputFields,
    };
    showCustomerCaptureDialog(props);
  });
};
